import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import DoneMessages from "../Utils/DoneMessage";
import uniqid from "uniqid";
import Cookies from "universal-cookie";
const cookie = new Cookies();

require("../../assets/stylesheets/SignIn/SignIn.css");

function SignUp({ children }) {
  if (cookie.get("username")) {
    window.location.href = "./categories";
  }

  const [content, setContent] = useState({
    username: "",
    email: "",
    password: "",
  });
  const [text, setText] = useState("");
  const [code, setCode] = useState(200);
  const [messageView, setMessageView] = useState(false);
  useEffect(() => {}, [messageView]);

  const regexEmail = () => {
    const re =
      /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
    if (!re.exec(content.email)) {
      return true;
    } else {
      if (
        content.email.includes("@gmail.com") ||
        content.email.includes("@hotmail.com") ||
        content.email.includes("@yahoo.com") ||
        content.email.includes("@uth.hn") ||
        content.email.includes("@outlook.com")
      ) {
        return false;
      } else {
        return true;
      }
    }
  };

  const handleSubmit = (e) => {
    setMessageView(false);
    e.preventDefault();

    if (handleDisabled) {
      const newUser = {
        username: content.username,
        email: content.email,
        password: content.password,
        level: 1,
        id: uniqid(),
        type: "platform_acount",
        likes: [],
      };

      axios
        .post(
          "https://ferias-ingenio-backend.vercel.app/api/users/adduser",
          newUser
        )
        .then((res) => {
          setText(res.data.message);
          setCode(res.data.code);
          setMessageView(true);
          if (res.data.code === 200) {
            cookie.set("id", newUser.id, { path: "/" });
            cookie.set("username", newUser.username, { path: "/" });
            cookie.set("email", newUser.email, { path: "/" });
            cookie.set("likes", content.likes, { path: "/" });
            cookie.set("level", content.level, { path: "/" });
            window.location.href = "./categories";
          }
        })
        .then((err) => {});

      setContent({
        username: "",
        email: "",
        password: "",
      });
    } else {
      setText("Informacion Incorrecta");
      setCode(400);
      setMessageView(true);
    }
  };

  const verifyTemporalEmails = (email) => {
    if (
      email.includes("@weepm.com") ||
      email.includes("@yefx.info") ||
      email.includes("jiooq.com") ||
      email.includes("@vusra.com") ||
      email.includes("@yopmail.fr") ||
      email.includes("@yopmail.net") ||
      email.includes("@cool.fr.nf") ||
      email.includes("@jetable.fr.nf") ||
      email.includes("@courriel.fr.nf") ||
      email.includes("@moncourrier.fr.nf") ||
      email.includes("@monemail.fr.nf") ||
      email.includes("@monmail.fr.nf") ||
      email.includes("@hide.biz.st") ||
      email.includes("@mymail.infos.st") ||
      email.includes("@catdogmail.live") ||
      email.includes("@mozej.com") ||
      email.includes("@mailna.co") ||
      email.includes("@mailna.in") ||
      email.includes("@mailna.me") ||
      email.includes("@mohmal.im") ||
      email.includes("@mohmal.in") ||
      email.includes("@xcapitalhg.com")
    ) {
      return "inputError";
    } else {
      return "";
    }
  };

  const validate = (text) => {
    if (
      text.includes("[") ||
      text.includes("]") ||
      text.includes("{") ||
      text.includes("}") ||
      text.includes('"') ||
      text.includes("|") ||
      text.includes("&") ||
      text.includes("`") ||
      text.includes("*") ||
      text.includes("+") ||
      text.includes(";")
    ) {
      return "inputError";
    } else {
      return "input";
    }
  };

  const handleDisabled = () => {
    if (
      validate(content.username) == "input" &&
      validate(content.email) == "input" &&
      verifyTemporalEmails(content.email) == "" &&
      !regexEmail()
    ) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      {messageView && (
        <DoneMessages text={text} code={code} visibility={messageView} />
      )}
      <form className="small-formInputs" onSubmit={handleSubmit}>
        <h1>Registra tu cuenta</h1>
        <div className="input-group">
          <input
            type="text"
            className={`large ${validate(content.username)}`}
            value={content.username}
            onChange={(e) => {
              setContent({ ...content, username: e.target.value });
              handleDisabled();
            }}
            required
            name="username"
          />
          {validate(content.username) == "inputError" && (
            <p className="onError">No se permiten caracteres especiales</p>
          )}
          <label htmlFor="username" className="input-label">
            Usuario
          </label>
        </div>
        <div className="input-group">
          <input
            type="mail"
            className={`
            large
            ${validate(content.email)}
            ${verifyTemporalEmails(content.email)}
            `}
            value={content.email}
            onChange={(e) => {
              setContent({ ...content, email: e.target.value });
              handleDisabled();
              regexEmail();
            }}
            required
            name="email"
          />
          {validate(content.email) == "inputError" && (
            <p className="onError">No se permiten caracteres especiales</p>
          )}
          <label htmlFor="email" className="input-label">
            Correo
          </label>
          {verifyTemporalEmails(content.email) == "inputError" && (
            <p className="onError">No se permiten correos temporales</p>
          )}
          {regexEmail() && (
            <p className="onError">Ingresa tu correo personal</p>
          )}
        </div>
        <div className="input-group">
          <input
            type="password"
            className={`large input`}
            value={content.password}
            onChange={(e) =>
              setContent({ ...content, password: e.target.value })
            }
            required
          />
          <label htmlFor="email" className="input-label">
            Contraseña
          </label>
        </div>
        <button
          type="submit"
          className="small-btnForm"
          disabled={handleDisabled()}
        >
          Registrarse
        </button>
        {children}
      </form>
    </>
  );
}

export default SignUp;
